import { Chip as MuiChip, ChipProps } from '@mui/material';

import { Close } from '../icons';

export function Chip(props: ChipProps) {
  const { deleteIcon: deleteIconFromProps, size } = props;

  const deleteIcon = size === 'large' ? <Close /> : deleteIconFromProps;

  return <MuiChip {...props} deleteIcon={deleteIcon} />;
}
